import React, { useCallback } from 'react';
import Member from '../../components/Member';
import Timeline from '../../components/TimeLine';
import { aboutUs } from '../../data/aboutUs';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { useVoice } from '../../hooks/useVoice';
import Bounce from 'react-reveal/Bounce';
import Fade from 'react-reveal/Fade';
import WhyChooseUs from '../../components/WhyChooseUs';
import Slider from 'react-slick';
import { Helmet } from 'react-helmet';
import { TabSection } from '../../components/Tabs';
import FeaturedServices from '../../components/FeaturedServices';
import useTeamMembers from '../../hooks/useTeamMembers';
import Innovations from '../../components/Innovations';
import Milestones from '../../components/Milestones';
import { AiOutlineArrowRight } from 'react-icons/ai';

var settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
};

function About() {
  const Speak = useVoice();
  const { team, times } = useTeamMembers();

  return (
    <div id='about-us'>
      <Helmet>
        <title>About | Solaric</title>
        <link
          async
          rel='stylesheet'
          type='text/css'
          charset='UTF-8'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
        />
        <link
          async
          rel='stylesheet'
          type='text/css'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
        />
      </Helmet>
      <div className='heading-links bgAbout'>
        <Bounce>
          <h1>About Us</h1>
        </Bounce>
        <h6>
          <Link to='/' className='mr-2'>
            Home{' '}
          </Link>
          <span>{'>'}</span> About Us
        </h6>
        <div id='team'></div>
      </div>

      <div className='py-5'>
        <WhyChooseUs title='ABOUT SOLARIC' />
      </div>

      <div className='our-team text-center bg-white'>
        <div className='container header-title'>
          <Bounce>
            <h2 className='pb-3'>
              <span>The Team</span>
            </h2>
          </Bounce>
          <div className='team-container'>
            <h3>&rarr; Management</h3>
            <Slider {...settings}>
              {team.map((data) => {
                if (data?.memberType === 'management') return <Member key={data.id} data={data} management />;
              })}
            </Slider>
          </div>
          <div className='team-container mt-5'>
            <h3>&rarr; Engineering</h3>
            <Slider {...settings}>
              {team.map((data) => {
                if (data?.memberType === 'engineering') return <Member key={data.id} data={data} />;
              })}
            </Slider>
          </div>
          <div className='mt-5 d-flex justify-content-center'>
            <Link to='/about/theTeam' className='more-container'>
              Know More
              <AiOutlineArrowRight className='icon' />
            </Link>
          </div>
        </div>
      </div>

      <FeaturedServices />
      <TabSection />

      <Innovations />
      <Milestones times={times} />
    </div>
  );
}

export default About;
